;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { Col, Row } from 'reactstrap';
import { MdCompareArrows, MdContentPaste, MdFavoriteBorder, MdManageSearch, MdOutlineChevronRight } from 'react-icons/md';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import useData from '../../../hooks/useData';
import { useUser } from '../../../contexts/UserContext';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';
import { useParams } from 'next/navigation';

type Props = {
  dictionary: Partial<Dictionaries>;
};
const DashboardOverview = ({ dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { data: savedSearches } = useData<SavedSearch[]>('/searches');
  const { data: applications } = useData<JobApplication[]>('/applications');
  const { data: jobMatchResponse } = useData<JobMatchResponse>('/job-matches?maxHitsOverride=20');
  const { candidate } = useUser();
  const { locale } = useParams();

  return (
    <section className="mysynergie-dashboard-overview mySynergie">
      <h2 className="mb-3">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_overview' }))}</h2>
      <Row className="gx-3 gx-xl-4">
        <Col xs={6} xl={3}>
          <Link
            href={`/${locale}/my-synergie/favorite-jobs`}
            className="overview-tile d-flex flex-column justify-content-between p-3 mb-3"
          >
            <div className="overview-tile-icon d-flex align-items-center justify-content-center">
              <MdFavoriteBorder size={16} />
            </div>
            <div>
              <div className="overview-tile-amount mb-1">{candidate?.favoriteJobIds?.length || 0}</div>
              <div className="d-flex align-items-end justify-content-between">
                <h4 className="overview-tile-title mb-0 text-uppercase">{formatMessage({ id: 'mysynergie_favorites' })}</h4>
                <MdOutlineChevronRight className="chevron-right d-none d-md-block" />
              </div>
            </div>
          </Link>
        </Col>
        <Col xs={6} xl={3}>
          <Link
            href={`/${locale}/my-synergie/job-applications`}
            className="overview-tile d-flex flex-column justify-content-between p-3 mb-3"
          >
            <div className="overview-tile-icon d-flex align-items-center justify-content-center">
              <MdContentPaste size={16} />
            </div>
            <div>
              <div className="overview-tile-amount mb-1">{applications?.length || 0}</div>
              <div className="d-flex align-items-end justify-content-between">
                <h4 className="overview-tile-title mb-0 text-uppercase">{formatMessage({ id: 'mysynergie_applications' })}</h4>
                <MdOutlineChevronRight className="chevron-right d-none d-md-block" />
              </div>
            </div>
          </Link>
        </Col>
        <Col xs={6} xl={3}>
          <Link
            href={`/${locale}/my-synergie/saved-searches`}
            className="overview-tile d-flex flex-column justify-content-between p-3 mb-3"
          >
            <div className="overview-tile-icon d-flex align-items-center justify-content-center">
              <MdManageSearch size={16} />
            </div>
            <div>
              <div className="overview-tile-amount mb-1">{(savedSearches && savedSearches.length) || 0}</div>
              <div className="d-flex align-items-end justify-content-between">
                <h4 className="overview-tile-title mb-0 text-uppercase textContainer">
                  {formatMessage({ id: 'mysynergie_searches' })}
                </h4>
                <MdOutlineChevronRight className="chevron-right d-none d-md-block" />
              </div>
            </div>
          </Link>
        </Col>
        <Col xs={6} xl={3}>
          <Link
            href={`/${locale}/my-synergie/jobmatches`}
            className="overview-tile d-flex flex-column justify-content-between p-3 mb-3"
          >
            <div className="overview-tile-icon d-flex align-items-center justify-content-center">
              <MdCompareArrows size={16} />
            </div>
            <div>
              <div className="overview-tile-amount mb-1">{jobMatchResponse?.count || 0}</div>
              <div className="d-flex align-items-end justify-content-between">
                <h4 className="overview-tile-title mb-0 text-uppercase textContainer">
                  {formatMessage({ id: 'mysynergie_jobmatches' })}
                </h4>
                <MdOutlineChevronRight className="chevron-right d-none d-md-block" />
              </div>
            </div>
          </Link>
        </Col>
      </Row>
    </section>
  );
};

export default DashboardOverview;
